import { files } from '../../../libs/assets';

export const helpfulLinks = {
  customisingEmailNotificationMessage: {
    href: 'https://help.formpl.us/s/article/how-to-customise-submission-email-notification-message',
    text: 'Customise email notification message'
  },
  includeResponseInNotificationEmail: {
    href: 'https://help.formpl.us/s/article/include-form-responses-and-add-responses-as-an-attachment-in-submission-notification-emails',
    text: 'How to include user’s response in notification email'
  },
  attachingDocumentInAutoresponder: {
    href: 'https://help.formpl.us/s/article/Attaching-Custom-documents-to-your-autoresponder',
    text: 'Attaching custom documents to your autoresponders'
  },
  customisingAutoresponderMessage: {
    href: 'https://help.formpl.us/s/article/how-to-customize-autoresponder-message',
    text: 'How to customise an autoresponder message'
  },
  receivingSubmissionsAsPDFOrDocx: {
    href: 'https://help.formpl.us/s/article/include-form-responses-and-add-responses-as-an-attachment-in-submission-notification-emails',
    text: 'Receive submissions as PDF/Doc attachments'
  },
  sendingMultipleAutoresponders: {
    href: 'https://help.formpl.us/s/article/sending-multiple-autoresponder',
    text: 'Sending multiple autoresponders'
  },
  displayingImageInAttachment: {
    href: 'https://help.formpl.us/s/article/viewing-images-directly-on-attachments',
    text: 'How to display images on your attachments'
  },
  createFormInAnotherLanguage: {
    href: 'https://formplusapp.my.site.com/help/s/article/create-a-form-in-another-language',
    text: 'Create a form in another language'
  },
  settingSubmissionStartDate: {
    href: 'https://help.formpl.us/s/article/Setting-a-submission-start-date-for-a-form',
    text: 'Setting a submission start date for a form'
  },
  integratingGoogleAnalytics: {
    href: 'https://help.formpl.us/s/article/integrating-google-analytics-to-your-form',
    text: 'Learn more how to integrate google analytics with Formplus'
  },
  whatCanIBuildWithFormplus: {
    href: `https://formplusapp.my.site.com/help/s/article/what-can-i-build-with-formplus`,
    text: `What can I build with Formplus`
  },
  allowingSubmissionEditing: {
    href: 'https://help.formpl.us/s/article/how-to-let-respondents-edit-their-form-submissions',
    text: 'How to let respondents edit their form submissions'
  },
  howToSaveAndAccessReports: {
    href: 'https://help.formpl.us/s/article/how-to-save-access-and-share-your-reports',
    text: 'How to Save, Access and Share your reports'
  },
  paymentGatewayComparison: {
    href: 'https://www.formpl.us/payments/payment-gateway-comparison',
    text: 'Payment gateway comparison page'
  },
  usingFormplusOnMyWebsite: {
    href: 'https://help.formpl.us/s/article/can-i-use-formplus-forms-on-my-website',
    text: 'Can I use Formplus forms on my website'
  },
  customSubmissionMessage: {
    href: 'https://formplusapp.my.site.com/help/s/article/add-a-custom-submission-message-to-your-form',
    text: 'Add a custom submission message to your form'
  },
  deletingResponseFilters: {
    href: 'https://help.formpl.us/s/article/how-to-delete-a-filter',
    text: 'How to delete a response filter'
  },
  usingFormplusOnMySheet: {
    href: 'https://help.formpl.us/s/article/using-formulas-in-your-form-response-sheets2',
    text: 'Using formula in your Formplus response sheet'
  },
  calculatingDateAndTime: {
    href: 'https://help.formpl.us/s/article/Calculating-Dates-and-Times',
    text: 'Calculating date and times'
  },
  calculationExampleForm: {
    href: 'https://www.formpl.us/form/4711261931438080',
    text: 'View example form'
  },
  editingResponseFilters: {
    href: 'https://help.formpl.us/s/article/how-to-edit-a-filter',
    text: 'How to edit a response filter'
  },
  flutterwaveIntegration: {
    href: 'https://help.formpl.us/s/article/integrating-the-flutterwave-payment-gateway-in-an-online-form',
    text: 'Learn more about Flutterwave Integration'
  },
  howToSendAutoresponder: {
    href: 'https://help.formpl.us/s/article/send-an-autoresponder-to-your-form-respondent-after-a-successful-form-submission',
    text: 'Learn more about autoresponders'
  },
  customisingFormButtons: {
    href: 'https://help.formpl.us/s/article/Customising-the-Buttons-in-Your-Form',
    text: 'Read support article on customising buttons on your forms'
  },
  howToCreateCustomLink: {
    href: 'https://help.formpl.us/s/article/how-to-create-a-custom-url-for-a-form',
    text: 'How to create a custom URL for your form'
  },
  periodicNotifications: {
    href: 'https://help.formpl.us/s/article/receive-email-notifications-of-form-submissions',
    text: 'Learn more about email notifications'
  },
  settingUpOfflineForm: {
    href: 'https://help.formpl.us/s/article/offline-forms---how-form-submission-without-an-internet-connection-works',
    text: 'How to set up offline forms'
  },
  howToSendBulkInvites: {
    href: 'https://help.formpl.us/s/article/sending-bulk-email-invites-to-your-respondents',
    text: 'How to share forms via email invitation'
  },
  howToShortenFormLink: {
    href: 'https://help.formpl.us/s/article/how-to-shorten-your-form-link',
    text: 'How to shorten your form links'
  },
  changingFormSetting: {
    href: 'https://formplusapp.my.site.com/help/s/article/change-your-form-settings',
    text: 'Change your forms settings'
  },
  multipleFileUploads: {
    href: 'https://formplusapp.my.site.com/help/s/article/Allowing-Multiple-File-Uploads-in-a-Form',
    text: 'Allowing multiple file uploads on a single form'
  },
  limitingSubmissions: {
    href: 'https://help.formpl.us/s/article/limiting-a-forms-total-number-of-form-submissions',
    text: 'How to limit number of form submissions'
  },
  paystackIntegration: {
    href: 'https://help.formpl.us/s/article/Integrating-the-Paystack-payment-processor-in-your-Formplus-form',
    text: 'Learn more about Paystack Integration'
  },
  introductionToTeams: {
    href: 'https://formplusapp.my.site.com/help/s/article/introduction-to-teams',
    text: 'Introduction to teams'
  },
  changingDefaultText: {
    href: 'https://formplusapp.my.site.com/help/s/article/changing-default-texts-for-your-form',
    text: 'Changing default texts for your form'
  },
  paymentIntegration: {
    href: 'https://help.formpl.us/s/article/payment-integrations-in-formplus',
    text: 'Payments integrations in Formplus'
  },
  calculationInTable: {
    href: 'https://help.formpl.us/s/article/how-to-use-form-calculations-in-a-table-field-repeating-data-sections',
    text: 'Using calculations in a table'
  },
  calculationArticle: {
    href: 'https://help.formpl.us/s/article/Adding-Calculation-to-Your-Form-Builder-Page',
    text: 'Adding calculations to your form'
  },
  emailNotifications: {
    href: 'https://help.formpl.us/s/article/receive-email-notifications-of-form-submissions',
    text: 'Learn more about email notifications'
  },
  markdownCheatSheet: {
    href: 'https://help.formpl.us/s/article/Markdown-Cheatsheet-Add-Text-Paragraphs-Lists-Links-and-Formatting-to-a-Form',
    text: 'Markdown cheat sheet'
  },
  creatingCustomLink: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-to-create-a-custom-url-for-a-form',
    text: 'Creating custom URL form link'
  },
  partialSubmissions: {
    href: 'https://help.formpl.us/s/article/partial-submissions',
    text: 'Read on Partial Submissions'
  },
  uniqueSubmissionId: {
    href: 'https://help.formpl.us/s/article/how-to-use-unique-submission-id-in-formplus',
    text: 'How to use unique submission Id in Formplus'
  },
  paypalIntegration: {
    href: 'https://help.formpl.us/s/article/integrating-paypal',
    text: 'Learn more about Paypal Integration'
  },
  stripeIntegration: {
    href: 'https://help.formpl.us/s/article/integrating-your-stripe-account',
    text: 'Learn more about Stripe Integration'
  },
  formCustomisation: {
    href: 'https://help.formpl.us/s/topic/0TO6g000000U09RGAS/form-customization',
    text: 'Customise your forms'
  },
  howToUseFormTimer: {
    href: 'https://help.formpl.us/s/article/Timer',
    text: 'How to use form timer'
  },
  logicExampleForm: {
    href: 'https://www.formpl.us/form/5376903076511744',
    text: 'View example form'
  },
  viewingResponses: {
    href: 'https://formplusapp.my.site.com/help/s/article/viewing-responses-in-formplus',
    text: 'Viewing responses in Formplus'
  },
  howAnalyticsWork: {
    href: 'https://help.formpl.us/s/article/how-does-form-analytics-work',
    text: 'How does form analytics work?'
  },
  conditionalLogic: {
    href: 'https://help.formpl.us/s/article/How-to-Use-Form-Logic-Builder-Page',
    text: 'Read support article on conditional logic'
  },
  sharingTemplates: {
    href: 'https://help.formpl.us/s/article/share-a-form-as-a-template-with-another-formplus-user',
    text: 'Learn how to share templates with other users'
  },
  introClosingPage: {
    href: 'https://formplusapp.my.site.com/help/s/article/add-an-intro-page-to-a-form',
    text: 'Adding intro pages to your forms'
  },
  usingBasicLookup: {
    href: 'https://help.formpl.us/s/article/using-basic-lookup',
    text: 'Using Basic Lookup'
  },
  previewingForms: {
    href: 'https://help.formpl.us/s/article/Previewing-Forms',
    text: 'Previewing Forms?'
  },
  makeFormPrivate: {
    href: 'https://help.formpl.us/s/article/how-to-make-a-form-private',
    text: 'How to make a form private'
  },
  saveAndContinue: {
    href: 'https://formplusapp.my.site.com/help/s/article/save-and-continue-later-allow-your-form-respondents-save-their-form-progress',
    text: 'Read support article on the save and continue feature'
  },
  customSubDomain: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-to-create-a-custom-url-for-a-form',
    text: 'Using the custom subdomain feature'
  },
  invoiceDownload: {
    href: 'https://help.formpl.us/s/article/how-can-i-download-my-invoice',
    text: 'Read on downloading invoices'
  },
  addingFormField: {
    href: 'https://formplusapp.my.site.com/help/s/article/Adding-a-Form-Field',
    text: 'Adding a form field'
  },
  addingCustomCSS: {
    href: 'https://help.formpl.us/s/article/adding-custom-css-to-your-form',
    text: 'Adding custom CSS to your form'
  },
  teamInvitation: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-to-invite-members-to-your-team',
    text: 'How to invite members to your team'
  },
  wordpressEmbed: {
    href: 'https://help.formpl.us/s/article/a-guide-to-embedding-your-forms-on-wordpress',
    text: 'A guide to Wordpress embeds'
  },
  creatingThemes: {
    href: 'https://help.formpl.us/s/article/how-to-create-your-own-form-theme',
    text: 'How to create your form theme'
  },
  signatureField: {
    href: 'https://formplusapp.my.site.com/help/s/article/Signature-Field',
    text: 'Read Support article on the signature field'
  },
  usingTemplates: {
    href: 'https://help.formpl.us/s/article/using-form-templates1',
    text: 'See article on how to use templates'
  },
  documentMerge: {
    href: 'https://help.formpl.us/s/article/How-To-Use-Formplus-Document-Merge',
    text: 'Learn more about document merge'
  },
  templatesPage: {
    href: `${location.origin}/templates`,
    text: 'Go to Templates Page'
  },
  importingData: {
    href: 'https://help.formpl.us/s/article/importing-data-to-your-form',
    text: 'Learn more about data import in Formplus'
  },
  requiredField: {
    href: 'https://formplusapp.my.site.com/help/s/article/value-for-this-field-is-required',
    text: 'Value for this field is required'
  },
  plainFileLink: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-do-i-make-the-link-to-my-file-upload-plain-url-instead-of-hyperlink',
    text: 'How do I make the link to my file upload plain URL instead of hyperlink?'
  },
  responseViews: {
    href: 'https://help.formpl.us/s/article/types-of-response-views-in-formplus',
    text: 'Type of response views in Formplus'
  },
  emailReminder: {
    href: 'https://help.formpl.us/s/article/email-reminders',
    text: 'Email reminders'
  },
  websiteEmbed: {
    href: 'https://help.formpl.us/s/article/embedding-a-form-on-your-website',
    text: 'Embedding a form on your website'
  },
  creatingTeam: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-to-create-a-team2',
    text: 'How to create a team'
  },
  deletingTeam: {
    href: 'https://formplusapp.my.site.com/help/s/article/deleting-a-team',
    text: 'How to delete a team'
  },
  editResponse: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-to-let-respondents-edit-their-form-submissions',
    text: 'How to let respondents edit their forms'
  },
  cloudStorage: {
    href: 'https://formplusapp.my.site.com/help/s/article/change-cloud-storage-option',
    text: 'Read on Cloud storage options'
  },
  fileDownload: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-to-download-files-submitted-on-a-form',
    text: 'Downloading files submitted on a form'
  },
  defaultValue: {
    href: 'https://formplusapp.my.site.com/help/s/article/How-to-Set-Default-Value-for-Form-Fields',
    text: 'How to Set Default Value for Form Fields'
  },
  formBuilder: {
    href: 'https://help.formpl.us/s/article/The-Form-Builder',
    text: 'Formplus form builder'
  },
  fileStorage: {
    href: 'https://formplusapp.my.site.com/help/s/article/where-are-the-uploaded-files--submission-spreadsheets-kept',
    text: 'Where are the uploaded files and submission spreadsheets kept?'
  },
  closingForm: {
    href: 'https://help.formpl.us/s/article/closing-a-form',
    text: 'Closing a form'
  },
  joiningTeam: {
    href: 'https://formplusapp.my.site.com/help/s/article/how-to-join-a-team',
    text: 'How to join a team'
  },
  sharingForm: {
    href: 'https://help.formpl.us/s/article/how-to-publishshare-a-form',
    text: 'How to share a form'
  },
  formPrefill: {
    href: 'https://help.formpl.us/s/article/prefilling-form-fields',
    text: 'Using the prefill feature'
  },
  usingLookup: {
    href: 'https://help.formpl.us/s/article/The-Lookup-Field',
    text: 'Using the Lookup Field'
  },
  mobileForms: {
    href: 'https://help.formpl.us/s/article/are-formplus-forms-mobile-friendly',
    text: 'Read Support article on mobile forms'
  },
  formFields: {
    href: `https://help.formpl.us/s/article/Introduction-to-Form-Fields`,
    text: `Read support articles on all form fields`
  },
  mobileApp: {
    href: 'https://help.formpl.us/s/article/does-formplus-have-a-mobile-app',
    text: 'Does Formplus have a mobile app?'
  }
};

export const features = [
  {
    description: 'Formplus allows you to create online forms without writing any code - simply click or drag and drop your desired form fields into the intuitive form builder.',
    title: 'Build Forms Easily in Minutes',
    image: files.formBuildingIntro,
    name: 'Form Building',
    id: 'formBuilding',
    subFeatures: [
      {
        description: 'Build powerful forms on any device - no coding knowledge required.',
        icon: files.dragAndDropIcon,
        title: 'Drag and Drop',
        id: 'drag-and-drop',
        sections: [
          {
            description: 'Our easy to use form builder allows you to create powerful forms within minutes - simply click or drag and drop your desired form fields into the builder. It’s that easy, no programming skills required.',
            title: 'Drag and drop',
            type: 'section'
          },
          {
            type: 'guide',
            items: [
              {
                description: 'You can move fields to other form pages by dragging them up and down or by clicking the "Move" button.',
                title: 'Re-arrange fields on your form'
              },
              {
                description: 'Improve your form layout and experience by displaying more than one field or column on the same line seamlessly.',
                title: 'Organise your form using rows'
              }
            ]
          },
          {
            title: 'How to Use the Drag and Drop Feature',
            imageUrl: files.dragAndDropIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.whatCanIBuildWithFormplus,
          helpfulLinks.createFormInAnotherLanguage,
          helpfulLinks.addingFormField
        ]
      },
      {
        description: 'We have over 30 form fields to make your data collection easier.',
        title: 'Versatile Form Fields',
        icon: files.formFieldsIcon,
        id: 'form-fields',
        sections: [
          {
            description: 'Select from over 30 form fields and question types to make your data collection easier.',
            title: 'Explore Powerful Field Types',
            type: 'section'
          },
          {
            imageUrl: files.formFieldsIllustration,
            type: 'tutorial'
          },
          {
            type: 'guide',
            items: [
              {
                description: 'These fields check for validation against valid email and website formats.',
                title: 'Email and Website'
              },
              {
                description: 'Equipped with different types of validations. You can accept numerical values.',
                title: 'Number'
              },
              {
                description: 'Best used for receiving text based answers such as names, location, statements, e.t.c. You can set a minimum and maximum length of characters your users can input.',
                title: 'Short and Long Text Fields'
              },
              {
                description: 'You can use the Date & Time field for date and/or time-related questions. It is useful for creating calculations, booking appointments, specifying delivery dates in order forms, time sheets, and more. Learn more',
                title: 'Date and Time'
              },
              {
                description: 'The labeled input is useful for specifying a default text or format you want for a field.',
                title: 'Labelled Input'
              },
              {
                description: 'Allow respondents input their addresses, and receive address suggestions from Google Maps as they type with the auto-complete feature.',
                title: 'Address'
              },
              {
                description: 'This field is used for receiving files on a form. This gives your users the ability to attach files to their form submissions.',
                title: 'File Upload'
              },
              {
                description: 'This lets you add an image or embed a video content to your form directly. ',
                title: 'Image and Video'
              },
              {
                description: 'Use the table field to describe and classify multiple items, create lists and collect dynamic data in table format. While allowing respondents to add rows as they please.',
                title: 'Table'
              },
              {
                description: `The matrix field can be used as a Likert scale to collect respondents' attitudes and opinions and is especially useful when drafting questionnaires.`,
                title: 'Matrix'
              },
              {
                description: 'Use the single select/radio to add a dropdown field and radio to show all items with one possible answer. A radio field prevents the user from selecting more than one option.',
                title: 'Single Select and Radios'
              },
              {
                description: 'Use the multiple select to add a dropdown field and checkboxes to show all items while allowing respondents to select multiple options from the available options.',
                title: 'Multiple Select and Checkboxes'
              },
              {
                description: 'The Formplus online form builder includes a signature field that allows you to receive digital signatures from respondents. It is useful for creating electronic signature forms for contracts, agreements, and other documents.',
                title: 'Signature and Esign'
              },
              {
                description: 'Collect ratings from your respondents when you include any of the Ratings option in your form. Available options are "Star", "Heart", "Scale", "Smiley".',
                title: 'Ratings'
              }
            ]
          }
        ],
        links: [
          helpfulLinks.formFields,
          helpfulLinks.defaultValue,
          helpfulLinks.requiredField
        ]
      },
      {
        description: 'Design beautiful forms from one of over 1000 pre-made templates.',
        icon: files.formTemplateIcon,
        title: 'Form Templates',
        id: 'templates',
        sections: [
          {
            description: 'Choose a template that suits your needs with a single click and customize it to your preference with our intuitive form builder.',
            title: 'Start from 1000+  free templates',
            type: 'section'
          },
          {
            imageUrl: files.imacIcon,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.templatesPage,
          helpfulLinks.sharingTemplates,
          helpfulLinks.usingTemplates
        ]
      },
      {
        description: 'Show or hide fields based on answers by respondents.',
        title: 'Conditional Logic',
        id: 'conditional-logic',
        icon: files.logicIcon,
        sections: [
          {
            description: `With this feature you can show or hide form fields and pages based on answers provided by respondents.<br /><br />Improve the functionality of your form and collect more responses from as many fields as you need with short and relevant forms using Formplus’ form builder with conditional logic.`,
            title: 'Create smart forms with conditional logic',
            type: 'section'
          },
          {
            imageUrl: files.logicIllustration,
            type: 'tutorial'
          },
          {
            subTitle: 'Two things you can do with conditional logic;',
            type: 'guide',
            items: [
              {
                description: 'Display/hide certain question/form fields to respondents based on their previous answer(s), resulting in shorter and more personalised forms with a higher response rate. This can be applied to multiple fields at once.',
                title: 'Show/Hide fields'
              },
              {
                description: 'Let users skip entire form pages that may not be relevant to them.',
                title: 'Personalise respondents’ experience'
              }
            ]
          }
        ],
        links: [
          helpfulLinks.logicExampleForm,
          helpfulLinks.conditionalLogic
        ]
      },
      {
        description: 'Automatically perform calculations and display results on your form.',
        title: 'Calculating Form Fields',
        id: 'calculating-form-fields',
        icon: files.calculationIcon,
        sections: [
          {
            description: `Formplus’ calculating form fields helps you perform simple mathematical operations on form fields automatically.<br /><br />This feature can be used to process payments on product order forms, event registrations, online bookings, expense reimbursements, and online donation forms, as well as calculate date range for appointment bookings. Supported fields include Short text, Number, Date and time, Single-select, Checkboxes, and more.`,
            title: 'Calculate form fields with ease',
            type: 'section'
          },
          {
            type: 'guide',
            items: [
              {
                description: 'Perform simple mathematical operations like addition and subtraction on form fields automatically. This feature saves you from doing manual calculations yourself, ensuring accurate and efficient processing directly within the forms.',
                title: 'Basic Calculations'
              },
              {
                description: 'Much more than just addition and subtraction, you can also use Formplus calculating fields to perform smart and advanced calculations, like calculating the final price of an item after applying discounts or computing an assessment’s average grade. It’s like having a powerful calculator right inside your forms!',
                title: 'Advanced Operations'
              },
              {
                description: `The date/time field can be used to perform simple date/time-related arithmetic. This is useful when creating scheduling forms, calculating respondents' age, duration of time taken to perform a task, number of days selected by respondents, or other date-related calculations.`,
                title: 'Calculating Date and Time'
              }
            ]
          },
          {
            imageUrl: files.calculationIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.calculationExampleForm,
          helpfulLinks.calculationArticle,
          helpfulLinks.calculationInTable,
          helpfulLinks.calculatingDateAndTime,
        ]
      },
      {
        description: 'Create and access forms from any device.',
        title: 'Mobile Friendly Forms',
        icon: files.mobileFormIcon,
        id: 'mobile-forms',
        sections: [
          {
            description: 'Formplus ensures that all forms are mobile-responsive and compatible with any device. Easily manage and collect data on your mobile devices with our user-friendly optimized forms, providing a seamless form experience.',
            title: 'Create stunning and mobile-friendly forms',
            type: 'section'
          },
          {
            imageUrl: files.mobileFormIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.mobileForms,
          helpfulLinks.mobileApp,
          helpfulLinks.previewingForms
        ]
      }
    ]
  },
  {
    description: 'Collect information right the first time, and every-time. ',
    image: files.dataCollectionIntro,
    name: 'Data Collection',
    title: 'Collect Data',
    id: 'dataCollection',
    subFeatures: [
      {
        description: 'Populate field options with the data from previously submitted responses',
        icon: files.lookupIcon,
        title: 'Form Lookup',
        id: 'lookup-field',
        sections: [
          {
            description: `As the name implies, the Lookup field does exactly that, it “looks up” data from previously submitted forms. This field then links the data to a new form and then populates/auto completes the form with the old data.
              <br/ ><br />
              For example, a Lookup field can display a respondent’s name and email address based on responses they may have submitted in another form previously. This can be displayed as choice (Basic select, Multiple select, Radio and Checkboxes), text (Short text, and Email) or number fields.
              Adding a lookup field to your online forms is very easy and quick, sign in to Formplus Platinum or Enterprise account to try them out.
            `,
            title: 'Autocomplete forms with old data easily.',
            type: 'section'
          },
          {
            imageUrl: files.lookUpIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.usingLookup,
          helpfulLinks.usingBasicLookup
        ]
      },
      {
        description: 'Add a timer to your form to build anticipation for your event, encourage prompt responses, or get reliable test results.',
        icon: files.timerIcon,
        title: 'Timed Form',
        id: 'timed-form',
        sections: [
          {
            title: 'Create timed forms for different purposes',
            type: 'section',
            description: `
              You can add a timer/countdown to your form or set a start and end date/time for the form.
              <br /><br />
              Alternatively, you can also add a timer to your form to build anticipation for your event, encourage prompt responses, or get fair and accurate test results
            `
          },
          {
            imageUrl: files.timedFormIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.howToUseFormTimer,
          helpfulLinks.uniqueSubmissionId,
          helpfulLinks.settingSubmissionStartDate
        ]
      },
      {
        description: 'Collect digital signatures via online forms.',
        title: 'Electronic Signatures',
        id: 'electronic-signatures',
        icon: files.signatureIcon,
        sections: [
          {
            description: `
              Collecting electronic signatures via online forms is made easy with Formplus. All you need to do is add the signature field in the form builder. All received signatures will appear as images in your cloud storage once they are submitted.
              <br /><br />
              The online signature field is also very responsive and easy to use on any device – laptop, tablet, or smartphone. Users can sign and submit forms in minutes, without printing out paper forms.
            `,
            title: 'Capture signatures on any form',
            type: 'section'
          },
          {
            imageUrl: files.eSignatureIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.signatureField,
          helpfulLinks.cloudStorage,
          helpfulLinks.fileDownload
        ]
      },
      {
        description: 'Collect various files types of any size directly into your preferred cloud storage',
        icon: files.folderIcon,
        title: 'Collect Files',
        id: 'file-uploads',
        sections: [
          {
            title: 'Collect and store files from your online form',
            type: 'section',
            description: `
              Formplus forms come with the option to include file upload fields that allow you to receive files of any size. Resumes, cover letters, photos, and more. All of this can be received using any of the Formplus free online templates. Simply select a preset file-upload form template, customise it to suit your needs, and you’re good to go!
              <br />
              <a href="https://www.formpl.us/templates/file-upload-form" target="_blank">You can customise a file upload form template here</a>.
            `
          },
          {
            subTitle: 'More powerful things you cn do with the file upload feature:',
            type: 'guide',
            items: [
              {
                description: 'Formplus’ file manager makes it easy for you to organise your files into different folders for more efficient management. You can easily segment your files based on different categories and titles, making it a breeze to find, access, and manage them.',
                title: 'Easily segment and manage files'
              },
              {
                description: 'Easily access the files uploaded by respondents on your forms as email attachments when you opt to receive free email notifications ',
                title: 'View files as attachments'
              },
              {
                description: 'From photographs and documents to videos and audio, Formplus’ file upload feature allows you to receive files of any size or type on your forms.',
                title: 'Collect a variety of files'
              },
              {
                description: 'Rename files using Short texts, Emails, Labeled input, Single select, and Radio fields on your forms. ',
                title: 'Rename received files'
              }
            ]
          },
          {
            imageUrl: files.fileIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          },
          {
            description: 'The Formplus form builder is integrated with 3 robust cloud storage services: Dropbox, Google Drive, and Microsoft OneDrive. These integrations allow to send/receive file uploads directly in your cloud storage with online forms. You can take advantage of the free or paid plans on any of the cloud storage services, or take advantage of the free and unlimited Formplus cloud storage.',
            title: 'File Storage',
            type: 'section'
          },
          {
            description: 'Finding specific files in a sea of attachments can be a nightmare. Not anymore! Our intelligent tagging system allows you to categorise attachments according to your unique requirements. You can also create new folders to manage the files you have received.',
            title: 'File Management',
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.fileDownload,
          helpfulLinks.fileStorage,
          helpfulLinks.plainFileLink,
          helpfulLinks.multipleFileUploads
        ]
      },
      {
        description: 'With the user’s consent, you can determine the physical location of the person filling out your form.',
        title: 'Location of Respondents',
        icon: files.mapMarkerIcon,
        id: 'geolocation',
        sections: [
          {
            title: 'Collect location data automatically with user’s consent',
            type: 'section',
            description: `
              With the user’s consent, the Geolocation feature allows you to determine the physical location of the person filling out your form. This feature uses Google Maps Web Services to pinpoint the nearest physical address as well as the longitude and latitude.
              <br />This is very useful for fieldwork and survey forms that need to map the location of each submitted form.
            `
          },
          {
            imageUrl: files.locationIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          },
          {
            subTitle: 'Some other ways you can collect information concerning the location of your respondents include;',
            type: 'guide',
            items: [
              {
                description: 'The Address field is a field used to collect the addresses of your respondents, be it a home address, an office address, or an address you would like them to fill out.',
                title: 'Address Fields',
                link: {
                  href: 'https://formplusapp.my.site.com/help/s/article/Address-Field',
                  text: 'Read article on address field'
                }
              },
              {
                description: 'The Country Field, is a form field used to collect answers from your respondents that specifically have to do with countries. You can find the Country field in the Basic Fields tab on the Builder page.',
                title: 'Country Fields',
                link: {
                  href: 'https://formplusapp.my.site.com/help/s/article/Country-Field',
                  text: 'Read article on country field'
                }
              }
            ]
          }
        ]
      },
      {
        description: 'Allow respondents save partial form data and resume filling at a later time.',
        title: 'Save and Continue',
        id: 'save-and-continue',
        icon: files.saveIcon,
        sections: [
          {
            title: 'Allow respondents complete forms at their own pace',
            type: 'section',
            description: `
              Enabling the Save & Continue feature allows respondents to save their incomplete form submission, and continue filling it at a later time.
              <br /><br />
              They can choose to save the form, after which a personalised link is sent to their emails to enable them complete the form at a more convenient time.
            `
          },
          {
            imageUrl: files.saveAndContinueIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.saveAndContinue,
          helpfulLinks.partialSubmissions,
          helpfulLinks.viewingResponses
        ]
      }
    ]
  },
  {
    description: 'Formplus allows you to stylise your forms according to your brand. You have the perfect online forms with your logo, images and preferred colours.',
    image: files.formCustomisationIntro,
    name: 'Form Customisation',
    title: 'Customise forms',
    id: 'formCustomisation',
    subFeatures: [
      {
        description: 'Tweak your form fonts, colours, brand logos and more to give you the perfect online form in minutes, without CSS.',
        icon: files.formStylingIcon,
        title: 'Form Styling',
        id: 'form-styling',
        sections: [
          {
            description: `
              Don’t just send out basic forms, create beautiful forms tailored to your brand using Formplus. Tweak your form fonts, colours, background images, brand logos and more to give you the perfect online form in minutes, without CSS.
              <br />
              If you are a CSS guru, you will find that customisation options are numerous in Formplus - you can modify pre-built templates, form themes, form layout, and even stylise your forms using your own CSS.
              <br /><br />
              Learn more about styling forms <a target="_blank" href="https://help.formpl.us/s/topic/0TO6g000000U09RGAS/form-customization">here</a>.
            `,
            title: 'Create and send beautiful online forms, even without coding knowledge',
            type: 'section'
          },
          {
            imageUrl: files.formStylingIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.customisingFormButtons,
          helpfulLinks.changingDefaultText,
          helpfulLinks.addingCustomCSS
        ]
      },
      {
        description: 'You can include a welcome message and control what users see after they have filled your form',
        icon: files.introClosingPageIcon,
        title: 'Intro And Closing Pages',
        id: 'intro-and-closing-pages',
        sections: [
          {
            description: `With Formplus intro and closing pages, you can show a welcome message when respondents open your form and display important information after they submit it.`,
            title: 'Leave a message for your users before and after submission',
            type: 'section'
          },
          {
            description: `Give your forms a more personalised touch with Formplus' intro and closing pages. With the various customisation options available in this feature, you can write messages that fit your brand and/or respondents’ needs and drive engagement.`,
            title: 'Personalised messages for your respondents',
            type: 'section'
          },
          {
            description: `"The 'Redirect After Submission' feature in Formplus lets form owners direct respondents to a chosen website after form completion, whether it's another page or form. Simply input the destination you want visitors to get to. This is useful for follow-up or leading respondents to more info on your website.`,
            title: 'Redirect after submission',
            type: 'section'
          },
          {
            imageUrl: files.introClosingPageIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.introClosingPage,
          helpfulLinks.customSubmissionMessage,
          helpfulLinks.editResponse
        ]
      },
      {
        description: 'Change the default messages on your forms using custom texts.',
        icon: files.customTextIcon,
        title: 'Custom Text',
        id: 'custom-text',
        sections: [
          {
            description: `The custom text option in the Account & Settings page of your form allows you to customise the default text that is shown on your form. You can also change the text to any language of your choice.
              <br/ ><br />
              This option is useful if you will prefer to reword a default message or if you are targeting respondents that are non-English speaking as this will help them understand better.
            `,
            title: 'Make default texts easier to understand for your respondents',
            type: 'section'
          },
          {
            imageUrl: files.customTextIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.changingDefaultText,
          helpfulLinks.changingFormSetting,
          helpfulLinks.viewingResponses
        ]
      },
      {
        description: `Add your company's name into every form link with custom subdomains.`,
        icon: files.customSubDomainIcon,
        title: 'Custom Sub-Domain',
        id: 'custom-sub-domain',
        sections: [
          {
            description: `Having your brand in your URLs gives you that seal of proposal and your respondents will find it easy to remember.
              <br/ >
              With Formplus’ sub-domain feature, you can add your company's name into every form link. Instead of your form link that starting with "formpl.us" you can change the URL to "mycompany.formpl.us". The generated subdomain is usually added to your form link such that form link appears as such - <span class="sample-link">www.brandname.formpl.us/form/formID</span>.
            `,
            title: 'Promote your brand with custom form URLs',
            type: 'section'
          },
          {
            type: 'section',
            list: {
              subTitle: 'Subdomain helps to:',
              items: [
                'Create easy to remember form links',
                'Build customer trust, and',
                `Promote your company's name and brand`
              ]
            }
          }
        ],
        links: [
          helpfulLinks.creatingCustomLink,
          helpfulLinks.creatingCustomLink,
          helpfulLinks.customSubmissionMessage,
          helpfulLinks.changingDefaultText
        ]
      },
      {
        description: 'If you are a CSS guru, you can stylise your forms using your own CSS.',
        icon: files.customCssIcon,
        title: 'Custom CSS',
        id: 'custom-css',
        sections: [
          {
            description: `Don’t just send out basic forms, create beautiful forms tailored to your brand using Formplus. Tweak your form fonts, colours, background images, brand logos and more to give you the perfect online form in minutes, without CSS.
              <br/ ><br />
              If you are a CSS guru, you will find that customisation options are numerous in Formplus - you can modify pre-built templates, form themes, form layout, and even stylise your forms using your own CSS.
            `,
            title: 'Add CSS code to your forms for complete customisation',
            type: 'section'
          }
        ],
        links: [
          {
            ...helpfulLinks.addingCustomCSS,
            text: 'Using custom CSS in your form'
          },
          helpfulLinks.formCustomisation,
          helpfulLinks.creatingThemes,
        ]
      },
    ]
  },
  {
    description: 'Stay informed and collaborate efficiently.',
    title: 'Collaborate with Team Members ',
    image: files.teamCollaborationIntro,
    name: 'Team Collaboration',
    id: 'teamCollaboration',
    subFeatures: [
      {
        description: 'With team feature you can Invite multiple people to join you in analysing form data.',
        icon: files.createTeamIcon,
        title: 'Create a Team',
        id: 'create-team',
        sections: [
          {
            description: `With the Formplus builder, you can involve important collaborators in your data collection and analysis process.
              <br />
              The multiple user feature lets your teammates and potential collaborators log into a shared account and work together on forms and data. You can assign roles and permissions to the users, and give them full or limited access to various forms, folders, and responses.
              <br /><br />
              An Audit Trail shows all the changes that have been made to your forms, reports, themes, and responses. As an admin, you can add comments to each item on the trail, to organize and manage projects more efficiently.
            `,
            title: 'Collaborate on forms and data by adding users to your account',
            type: 'section'
          },
          {
            imageUrl: files.teamCollaborationIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          },
          {
            subTitle: 'With the teams feature, you can:',
            type: 'guide',
            items: [
              {
                description: 'Create forms and share them with team members. `Allow multiple people access to a form and it’s data.',
                title: 'Share forms with team members'
              },
              {
                description: 'Invite users to your team to collaborate on forms.',
                title: 'Add collaborators to your account'
              },
              {
                description: 'Allow users different access levels to team data.',
                title: 'Set Permissions to control account access'
              },
              {
                description: 'Collaborate effectively by adding notes to responses. <a target="_blank" href="https://formplusapp.my.site.com/help/s/article/adding-notes-to-a-submission">See here</a> for more information.',
                title: 'Add notes and comments to form responses'
              }
            ]
          },
          {
            description: `<b>Please Note:</b> Forms created in a team cannot be seen by team members of a different team except if they are also members of the team on which the form was created and also currently on the team. This feature is only available to users on the Professional, Platinum, and Enterprise plan with varying limits to the number of teams that can be created.
              <br /><br />
              Visit our <a href="https://formplusapp.my.site.com/help/s/article/introduction-to-teams" target="_blank">support article</a> for more information on the teams feature.
            `,
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.introductionToTeams,
          helpfulLinks.teamInvitation,
          helpfulLinks.joiningTeam,
          helpfulLinks.creatingTeam,
          helpfulLinks.deletingTeam
        ]
      },
      {
        description: 'Automatically send form submission data to team members and collaborators.',
        title: 'Email Notifications for Collaborators',
        icon: files.teamNotificationIcon,
        id: 'team-notification',
        sections: [
          {
            description: `Formplus lets you receive <a href="https://help.formpl.us/s/article/receive-email-notifications-of-form-submissions" target="_blank">notifications for form submissions</a>, these email notifications are sent to the email address associated with your Form+ account by default. You can choose to add other email addresses to receive submission notifications, you can also choose to exclude yourself from receiving notifications.`,
            title: 'Automatically send submission information to multiple email addresses.',
            type: 'section'
          },
          {
            imageUrl: files.teamNotificationIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          {
            ...helpfulLinks.emailNotifications,
            text: 'Receive email notifications of form submissions'
          },
          helpfulLinks.introductionToTeams,
          helpfulLinks.creatingTeam,
          helpfulLinks.teamInvitation
        ]
      }
    ]
  },
  {
    description: 'Built with your growth in mind, Formplus payment features are built to help you get paid from anywhere around the world.',
    image: files.paymentIntro,
    title: 'Accept Payments',
    name: 'Payments',
    id: 'payments',
    subFeatures: [
      {
        description: 'Integrated with the most secure online payment processors - PayPal, Stripe, Flutterwave and Paystack.',
        icon: files.paymentProcessorIcon,
        title: 'Payment Processors',
        id: 'payment-processor',
        sections: [
          {
            description: `With Formplus, you can make any type of order form and collect online payments easily. Our payment forms are secure and they integrate with the largest online payment processors in the industry (PayPal, Stripe, Flutterwave and Paystack).
              <br /><br />
              Collecting online payments doesn’t have to come with a lot of issues, with Formplus, most of the hard work is done already. No need to bother with APIs, documentation and developer fees, if you’ve got an account with PayPal, Stripe, Flutterwave or Paystack, you can collect online orders easily.
            `,
            title: 'Stress-free and secure payment integrations',
            type: 'section'
          },
          {
            imageUrl: files.paymentProcessorIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          },
          {
            subTitle: 'Our payment intergrations include;',
            type: 'guide',
            items: [
              {
                description: `PayPal remains one of the most trusted online payment processors.
                  <br /><br />
                  With Formplus’ integration, you can build PayPal forms that can quickly receive payments and donations for your business or organisation.
                `,
                link: {
                  href: 'https://help.formpl.us/s/article/integrating-paypal',
                  text: 'Learn more about Paypal Integration'
                },
                title: 'PayPal'
              },
              {
                description: `Formplus makes it faster and easier to receive payments using Stripe payment forms.
                  <br /><br />
                  The payment fields are embedded directly on your form so they can make instant payments, without a redirect to another page to complete the transaction.
                `,
                link: {
                  href: 'https://help.formpl.us/s/article/integrating-your-stripe-account',
                  text: 'Learn more about Stripe Integration'
                },
                title: 'Stripe'
              },
              {
                description: `With Formplus, you can easily collect payments for goods and services online, without writing a single line of code or building a platform from scratch.
                  <br /><br />
                  The Paystack integration is safe, secure and perfect for Africans who want to receive payments from anyone, anywhere in the world.
                `,
                link: {
                  href: 'https://help.formpl.us/s/article/Integrating-the-Paystack-payment-processor-in-your-Formplus-form',
                  text: 'Learn more about Paystack Integration',
                },
                title: 'Paystack'
              },
              {
                description: `The Formplus integration connects your forms with Flutterwave to help you safely collect payments and donations online. 
                  <br /><br />
                  Process payments for your goods and services from anywhere in the world, including Africa, right from your online form.
                `,
                link: {
                  href: 'https://help.formpl.us/s/article/integrating-the-flutterwave-payment-gateway-in-an-online-form',
                  text: 'Learn more about Flutterwave Integration',
                },
                title: 'Flutterwave'
              }
            ]
          },
          {
            description: `We protect all online forms - including payment-enabled forms - with our secure 256-bit SSL encryption and so your transactions are always safe. The smart CAPTCHA also prevents spam and form abuse.`,
            title: 'Secure Online Payments',
            type: 'section'
          },
          {
            description: `Formplus has a robust reports and email notifications system and with it you can understand, and present payment data easily.
              <br /><br />
              <b>Please Note:</b> Formplus does not have extra charges for third-party integrations like Google Drive, Dropbox, Stripe, PayPal, Flutterwave and Paystack.
            `,
            title: 'Track Payments and Data Performance',
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.paymentGatewayComparison,
          helpfulLinks.paymentIntegration
        ]
      },
      {
        description: `This feature keeps a real-time count of the remaining items, ensuring that you don't oversell your available stock.`,
        icon: files.inventoryFieldIcon,
        title: 'Inventory Field',
        id: 'inventory-field',
        sections: [
          {
            description: `The inventory feature allows you to effectively track and manage inventory. It functions like a digital store on your form, allowing you to enter important details about each item, like their category, usage, price, quantity left, and a restock timeline.
              <br /><br />
              This feature keeps a real-time count of the remaining items, ensuring that you don't oversell your available stock.
            `,
            title: 'Keep real time stock count of your items',
            type: 'section'
          },
          {
            imageUrl: files.inventoryPaymentIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.paymentIntegration,
          helpfulLinks.invoiceDownload
        ]
      },
      {
        description: `Reduce the risk of fraud and accept payments securely because we are Payment Card Industry compliant.`,
        title: 'PCI Compliance',
        id: 'pci-compliance',
        icon: files.pciIcon,
        sections: [
          {
            description: `Sell products, receive donations, and set up recurring submissions with Formplus’s PCI-compliant payment forms.
              <br /><br />
              We protect all online forms - including payment-enabled forms - with our secure 256-bit SSL encryption and so your transactions are always safe. The smart CAPTCHA also prevents spam and form abuse.
            `,
            title: 'Create Payment Card Industry (PCI) Compliant Forms.',
            type: 'section'
          },
          {
            description: '<b>Please Note:</b> Formplus does not have extra charges for third-party integrations like Google Drive, Dropbox, Stripe, PayPal, Flutterwave and Paystack.',
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.paymentGatewayComparison,
          helpfulLinks.paymentIntegration,
          helpfulLinks.paypalIntegration,
          helpfulLinks.stripeIntegration,
          helpfulLinks.paystackIntegration,
          helpfulLinks.flutterwaveIntegration
        ]
      },
      {
        description: `With Stripe subscriptions, you can provide your customers with flexible billing options.`,
        title: 'Re-occuring Subscriptions',
        icon: files.subscriptionIcon,
        id: 'subscription',
        sections: [
          {
            description: `Using our stripe integration, you can create online subscription forms that accept recurring payments — no coding required. Simply integrate your form with stripe and customise your subscription options to meet your exact needs.`,
            title: 'Accept Recurring Subscription Payments',
            type: 'section'
          },
          {
            imageUrl: files.stripeIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          },
          {
            description: 'Once you have connected your Stripe account to Formpus, you get to decide if you are selling a product or service and if you will be receiving single or recurring payments on your account. To add Stripe products to your Formplus payment form, you must have a Stripe account. The step below gives an explanation on how you can set this up on Formplus:',
            title: 'Adding Stripe products to your form',
            type: 'section',
            list: {
              lister: 'decimal',
              items: [
                'On your Stripe account dashboard create new products or add previously created products that you would like to sell on your online form. For example, we would be adding the Formplus Fairy Cookies to our Cookie Order Form',
                'Login to your Formplus account',
                'Create your Stripe  payment form by creating from scratch or get a headstart with one of the payment templates available on the templates page.',
                'On the Builder page > Payment section of your form, drag and drop or click on the Stripe icon to add it to the form. If the Stripe icon has been previously added to the form if you chose a payment form, then you skip this step.',
                'Click on the edit icon of the Stripe field to make changes to it.',
                'On the edit modal, scroll to the Field Option section. Check the “list stripe products on form”.',
                'Select the product to be displayed',
                'Choose a display format for the product either radio, basic select or stripe image.With Stripe image, add images for a pictorial description of the product.',
                'Click on the Save button.',
                'You are ready to test your form and start selling your product using an online form.'
              ]
            }
          }
        ],
        links: [
          {
            ...helpfulLinks.stripeIntegration,
            text: 'Integrating with Stripe'
          },
          helpfulLinks.paymentIntegration
        ]
      }
    ]
  },
  {
    description: 'Select from our wide range of sharing options how best you want to reach your respondents. Now your forms can be filled from anywhere, online and offline.',
    image: files.formSharingIntro,
    title: 'Share Forms',
    name: 'Form Sharing',
    id: 'formSharing',
    subFeatures: [
      {
        description: 'Customise and shorten your form links before sharing your forms to make it easy for respondents to remember.',
        icon: files.customUrlIcon,
        title: 'Custom Form URL',
        id: 'custom-url',
        sections: [
          {
            description: `Custom Form URLs are especially used for branding your form link. You can also use this feature to customise your shortened URL to include your brand name. For example, fpls.in/customname. These shortened links take up less space and keep the text in your branding materials tidy. For example, links on business cards, advertisement, or emails`,
            title: 'Make your form links easy to remember with custom form URLs',
            link: helpfulLinks.howToCreateCustomLink,
            type: 'section'
          },
          {
            description: `To keep form URLs tidy and on-brand, Formplus has a URL shortening service for forms created with Formplus. Just like most URL shorteners, you can view analytics for each form as well as track where your links are being clicked from.`,
            link: helpfulLinks.howToShortenFormLink,
            title: 'Shortened Form LInks',
            type: 'section'
          },
          {
            imageUrl: files.customUrlIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.sharingForm,
          helpfulLinks.howToCreateCustomLink,
          helpfulLinks.customSubDomain,
          {
            ...helpfulLinks.howToSendBulkInvites,
            text: 'Sending bulk email invites'
          }
        ]
      },
      {
        description: 'Save time and pre-populate your forms via URL.',
        icon: files.prePopulateFormIcon,
        title: 'Pre-populate Forms',
        id: 'pre-populate-form',
        sections: [
          {
            description: `Using pre-fill in Formplus allows you to pre-populate forms with URL parameters. This will help to save time and also improve accuracy when it comes to collecting data via forms, such as when Administrators need reports from team members.`,
            title: 'A fast, easy way to complete your online forms.',
            type: 'section'
          },
          {
            type: 'section',
            list: {
              title: 'How does it work?',
              lister: 'disc',
              items: [
                'Create a form and use our pre-fill tool to generate a custom pre-filled URL for each respondent.',
                'Share the pre-filled link with your respondents.',
                'Once they access your form via the link, the form fields are automatically filled with data based on the information passed via the URL. The respondents can then go on to input additional information.'
              ]
            },
            link: {
              ...helpfulLinks.formPrefill,
              text: 'Learn more about the pre-fill feature'
            }
          },
          {
            imageUrl: files.prePopulateFormIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          }
        ],
        links: [
          {
            ...helpfulLinks.importingData,
            text: 'Importing data into your form'
          },
          helpfulLinks.sharingForm,
          {
            ...helpfulLinks.howToCreateCustomLink,
            text: 'How to add links to your form'
          }
        ]
      },
      {
        description: 'Use QR Codes to easily share your forms.',
        title: 'Share Via QR Code',
        icon: files.qrCodeIcon,
        id: 'qr-code',
        sections: [
          {
            description: `On Formplus, you can share your form as a QR code for your respondents to access. SImply download the QR code of the form by clicking the "Download QR code" button from the share tab to proceed.
              <br /><br />
              This code is specific to each form and your respondents will need to have a QR code scanner in order to convert the QR codes to form links.
            `,
            title: 'A fast, easy way to share your online forms',
            type: 'section'
          },
          {
            type: 'section',
            list: {
              title: 'How can I generate a QR code to share my forms?',
              lister: 'decimal',
              items: [
                'Go to the Share tab in the Formplus builder environment.',
                'Select the QR code icons from the options.',
                'Select Download QR Code.'
              ]
            }
          },
          {
            imageUrl: files.qrCodeIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.sharingForm,
          {
            ...helpfulLinks.howToCreateCustomLink,
            text: 'How to add links to your form'
          },
          helpfulLinks.howToCreateCustomLink
        ]
      },
      {
        description: 'Embed your form into any website without writing code from scratch.',
        icon: files.embeddedFormIcon,
        title: 'Embedded Form',
        id: 'embedded-form',
        sections: [
          {
            description: `Do you need information from your site visitors on-the-go? Have your forms displayed as iframes or pop-ups on your website, without complications. With Formplus, you can easily <a href="https://help.formpl.us/s/article/embedding-a-form-on-your-website" target="_blank">embed your form</a> into any webpage; by using a quick copy and paste of a short code into your HTML.
              <br /><br />
              With the Facebook Tab Embed option, you can also display your forms as tabs on your official Facebook page. It is super simple to embed your form right into any webpage. No complications, no heavy lifting; just a quick copy and paste of a short code into your HTML.
              <br /><br />
              Formplus also has a WordPress plugin that lets you add forms to your website pages through a widget. Simply add the form shortcode to any page of your web pages and your form will be added immediately. Formplus make it easy for you to create and embed online forms on your website, no technical knowledge necessary.
            `,
            title: 'Embed any form into your website',
            type: 'section'
          },
          {
            imageUrl: files.embeddedFormIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.wordpressEmbed,
          helpfulLinks.websiteEmbed,
          helpfulLinks.usingFormplusOnMyWebsite
        ]
      },
      {
        description: 'Use the Wordpress plugin to embed forms to your Wordpress website.',
        icon: files.wordpressEmbedIcon,
        title: 'Wordpress Embed',
        id: 'wordpress-embed',
        sections: [
          {
            description: `Formplus has a WordPress plugin that lets you add forms to your website pages through a widget.
              <br /><br />
              Simply add the form shortcode to any page of your web pages and your form will be added immediately. Formplus make it easy for you to create and embed online forms on your website, no technical knowledge necessary.
            `,
            title: 'Embed any form into your wordpress website',
            type: 'section',
            link: {
              ...helpfulLinks.wordpressEmbed,
              text: 'How to embed your forms on wordpress'
            }
          },
          {
            imageUrl: files.wordpressEmbedIllustration,
            gradientColor: 'yellow',
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.wordpressEmbed,
          helpfulLinks.websiteEmbed,
          helpfulLinks.usingFormplusOnMyWebsite
        ]
      },
      {
        description: 'Allow your respondents submit forms anywhere, even offline.',
        icon: files.offlineFormsIcon,
        title: 'Offline Forms',
        id: 'offline-forms',
        sections: [
          {
            description: `This allows you to collect data in remote locations, or places without reliable internet connection. Offline forms ensure that you have a backup in cases where you have unreliable WiFi, such as large conferences and field surveys.
              <br /><br />
              Using conversational SMS to fill forms, you can collect data from people using their on phones, tablets, and other devices. With this, you can greatly increase your audience reach, as you do not need internet access to collect the data you need.
            `,
            title: 'Collect Data without Internet Access',
            link: helpfulLinks.settingUpOfflineForm,
            type: 'section'
          },
          {
            imageUrl: files.offlineFormsIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.closingForm,
          helpfulLinks.sharingForm,
          {
            ...helpfulLinks.howToSendBulkInvites,
            text: 'Sending bulk invites to your respondents'
          }
        ]
      },
      {
        description: 'Allows you track your online form submissions and limit submissions to one entry.',
        icon: files.emailInvitationIcon,
        title: 'Email Invitation',
        id: 'email-invitation',
        sections: [
          {
            description: `With Formplus, you can allow only one entry per email to prevent people from submitting multiple entries on your form. This helps you track your online form submissions and monitor when a respondent has filled the form.
              <br /><br />
            `,
            title: 'Prevent duplicate form submissions by tracking email invitations.',
            type: 'section',
            list: {
              title: 'How does it work?',
              lister: 'disc',
              items: [
                'Invite your respondents to submit your online form via email (by uploading their email addresses).',
                'Once they fill out the form, you can choose not to let them come back to fill or submit on that same form.',
                'You can also monitor pending and received responses at a glance; before a respondent fills out the form, there is a tab in their response sheets marked as “pending”. Upon submission, this changes to “submitted”.'
              ]
            },
            link: helpfulLinks.howToSendBulkInvites
          },
          {
            imageUrl: files.emailInvitationIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.emailReminder,
          helpfulLinks.sharingForm,
          helpfulLinks.formBuilder,
          helpfulLinks.markdownCheatSheet
        ]
      },
      {
        description: 'Set reminders to email invites that are yet to fill your form. Also send reminders to partial submissions.',
        icon: files.reminderEmailsIcon,
        title: 'Set Reminder Emails',
        id: 'reminder-emails',
        sections: [
          {
            description: `Formplus email reminders are friendly nudges that you can set up to remind people to fill out your forms. They're useful because they can boost the number of responses you get as well as keep respondents engaged.
              <br /><br />
            `,
            title: 'Boost form submissions with reminder emails',
            type: 'section',
            list: {
              subTitle: 'The Formplus reminder emails allow you to:',
              lister: 'disc',
              items: [
                'Personalise the email messages, and',
                `Choose when they're sent, all of which can make your form experience even better and help you collect the information you need.`
              ]
            }
          },
          {
            description: `You can send email reminders to respondents who have only <a href="https://help.formpl.us/s/article/partial-submissions" target="_blank">partially completed</a> your form or remind those you have invited to fill out your form via an <a href="https://help.formpl.us/s/article/sending-bulk-email-invites-to-your-respondents" target="_blank">email invite</a>.`,
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.emailReminder,
          helpfulLinks.sharingForm,
          helpfulLinks.formBuilder
        ]
      },
    ]
  },
  {
    description: 'Receive email notifications of submissions and send out a custom message to users upon successful form submission.',
    image: files.notificationIntro,
    title: 'Get Notifications',
    name: 'Notifications',
    id: 'notifications',
    subFeatures: [
      {
        description: 'You can send out confirmation emails to respondents upon submission.',
        icon: files.autoresponderIcon,
        title: 'Autoresponder',
        id: 'autoresponder',
        sections: [
          {
            description: `With autoresponders, you can send out a <a href="https://help.formpl.us/s/article/how-to-customize-autoresponder-message" target="_blank">custom message</a> to users as a confirmation email upon successful form submission.
              <br /><br />
              To eliminate miscommunication and mix-ups, you can also include submitted responses in the confirmation email. This also helps you take out several steps in your communication process, as you can send submission receipts immediately to their inbox
            `,
            title: 'Notify respondents with automatic email confirmations',
            link: helpfulLinks.howToSendAutoresponder,
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.sendingMultipleAutoresponders,
          helpfulLinks.customisingAutoresponderMessage,
          helpfulLinks.attachingDocumentInAutoresponder,
          helpfulLinks.allowingSubmissionEditing
        ]
      },
      {
        description: 'Receive email notifications of submissions and other important information concerning your form.',
        icon: files.emailNotificationsIcon,
        title: 'Email Notifications',
        id: 'email-notifications',
        sections: [
          {
            description: `With custom email notifications, you can notify staff and stakeholders that your online form has received new data.
              <br />
              Responses received via the forms can be shared as PDF files or Word documents, attached to emails. With this feature you can also select the frequency with which responses are shared with you or others once a respondent submits an entry. This could be received upon submission or as daily, weekly or monthly summaries.
            `,
            title: 'Send out form data to those who need it, as soon as they need it',
            link: helpfulLinks.emailNotifications,
            type: 'section'
          },
          {
            imageUrl: files.emailNotificationIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.customisingEmailNotificationMessage,
          helpfulLinks.includeResponseInNotificationEmail,
          helpfulLinks.receivingSubmissionsAsPDFOrDocx,
          helpfulLinks.displayingImageInAttachment
        ]
      },
      {
        description: 'Receive email notifications based on your preferred schedule. ',
        icon: files.periodicNotificationsIcon,
        title: 'Periodic Notifications',
        id: 'periodic-notifications',
        sections: [
          {
            description: `With custom email notifications, you can notify staff and stakeholders that your online form has received new data in whatever duration you prefer.
              <br /><br />
              You can set notifications to be delivered with every new response or have a summary delivered to multiple stakeholders periodically, either daily, weekly or monthly.
            `,
            title: 'Notify respondents with automatic email confirmations periodically',
            link: helpfulLinks.periodicNotifications,
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.customisingEmailNotificationMessage,
          helpfulLinks.includeResponseInNotificationEmail,
          helpfulLinks.receivingSubmissionsAsPDFOrDocx,
          helpfulLinks.displayingImageInAttachment
        ]
      },
      {
        description: 'Create customised PDF and Word documents from form submissions.',
        icon: files.documentMergeIcon,
        title: 'Document Merge',
        id: 'document-merge',
        sections: [
          {
            description: `Build professional-looking documents from form submissions with your own custom document templates. Save time and resources by automating documents like receipts, invoices, contracts and so much more.
              <br /><br />
            `,
            title: 'Attach beautifully designed documents from form submissions to emails',
            type: 'section',
            list: {
              subTitle: 'Merge form data in documents seamlessly for use in:',
              lister: 'disc',
              items: [
                'HR Documents',
                'You can create offer letters, onboarding documents as well as other important HR documents.',
                'Education',
                'Send out certificates, documents, fee receipts, etc. once students and staff fill out your forms.',
                'Purchase & Sales Orders',
                'Complete purchase orders in minutes once a form is filled out.',
                'Invoices & Receipts',
                'Issue out branded invoices and receipts for your organization, without manually sending out emails every time.',
                'Contracts & Agreements',
                'Seal agreements by formatting contracts from details entered in forms.'
              ]
            }
          }
        ],
        links: [
          {
            ...helpfulLinks.attachingDocumentInAutoresponder,
            text: 'How to attach custom documents to autoresponder'
          },
          helpfulLinks.receivingSubmissionsAsPDFOrDocx,
          helpfulLinks.displayingImageInAttachment
        ]
      }
    ]
  },
  {
    description: 'Gain insights from forms and submissions with Analytics. View data such as unique form views, top devices, browsers and more.',
    image: files.analyticsIntro,
    title: 'Data Analytics',
    name: 'Analytics',
    id: 'analytics',
    subFeatures: [
      {
        description: 'Observe analytics on your form and gain key insights on your business.',
        icon: files.analyticsIcon,
        title: 'Analytics',
        id: 'analytics',
        sections: [
          {
            description: `Analyze respondents data, learn from customer behaviour and improve your form conversion rate. Know exactly how many people fill out your form, where they’re from, and what devices they’re using right in Formplus. No need to write a single line of code, everything is automated.
              <br /><br />
              The form analytics dashboard displays statistics like the number of daily or weekly submissions, country/region where each submission is from, and the devices used. You can also view metrics like form submission count, total form views, unique views, abandonment rate, conversion rate and average time to track how your forms are doing.
              <br /><br />
              Formplus also lets you build custom visual reports in a few clicks with the robust reports summary tool. Select the data(field) you would like to display, and instantly view beautiful graphs and charts.
            `,
            title: 'Gather useful insights from your form data to reduce abandonment rates',
            type: 'section',
            link: {
              href: 'https://help.formpl.us/s/article/what-you-need-to-know-about-using-reports-in-formplus',
              text: 'Learn more about reports in Formplus'
            }
          },
          {
            imageUrl: files.formAnalyticsIllustration,
            type: 'tutorial'
          },
          {
            subTitle: 'With the Analytics page you can view respondents details like;',
            link: helpfulLinks.howAnalyticsWork,
            type: 'section',
            items: [
              'Unique visits',
              'Abandonment Rate',
              'Conversion rate',
              'Average time spent in seconds',
              'Map of user location (If location is enabled)',
              'Device Usage'
            ]
          },
          {
            description: `As a marketer using Formplus, you may be interested in getting more insight and to analyze in-depth details about people filling your form.
              <br /><br />
              Formplus now provides the option of integrating Google Analytics tracking ID into your form for better insights.
            `,
            link: helpfulLinks.integratingGoogleAnalytics,
            title: 'Using Google Analytics with Formplus',
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.usingFormplusOnMySheet,
          helpfulLinks.includeResponseInNotificationEmail,
          helpfulLinks.receivingSubmissionsAsPDFOrDocx,
          {
            ...helpfulLinks.partialSubmissions,
            text: 'Partial Submissions'
          }
        ]
      },
      {
        description: 'Organise your data into charts and reports that reflect in real time.',
        icon: files.reportsBuilderIcon,
        title: 'Reports Builder',
        id: 'reports-builder',
        sections: [
          {
            description: `You can convert form responses into visually stunning reports with customisable charts, graphs, grids, and more. Your automated report will immediately update after each new submission.
              <br /><br />
              Reports are also used to get an instant summary of your submissions. which can be downloaded, printed or shared as a link.
            `,
            title: 'Organise your data into charts and reports in real-time.',
            type: 'section',
            link: {
              href: 'https://help.formpl.us/s/article/what-you-need-to-know-about-using-reports-in-formplus',
              text: 'Learn more about reports in Formplus'
            }
          },
          {
            imageUrl: files.reportsBuilderIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.howToSaveAndAccessReports,
          {
            ...helpfulLinks.partialSubmissions,
            text: 'Partial Submissions'
          },
          helpfulLinks.receivingSubmissionsAsPDFOrDocx,
          helpfulLinks.displayingImageInAttachment
        ]
      },
      {
        description: 'Capture data from incomplete submissions.',
        icon: files.partialSubmissionsIcon,
        title: 'Partial Submissions',
        id: 'partial-submissions',
        sections: [
          {
            description: `Enabling the <a href="https://help.formpl.us/s/article/save-and-continue-later-allow-your-form-respondents-save-their-form-progress" target="_blank">Save & Continue later feature</a> allows respondents to save their responses. They can choose to save the form and send the personalised link to their email to submit the completed form at a more convenient time.
              <br />
              Once it is enabled on a form, users can save their form entries, and are then provided with a link that takes them back to the submission in progress.
              <br />
              Formplus also has Partial Submissions to help capture form data from incomplete submissions. With this, you can send reminder emails to respondents that are yet to submit their responses.
            `,
            title: 'Allow user save partial form data and resume filling at a later time',
            type: 'section',
            link: {
              href: 'https://help.formpl.us/s/article/partial-submissions',
              text: 'Learn more about partial submissions in Formplus'
            }
          }
        ],
        links: [
          {
            ...helpfulLinks.saveAndContinue,
            text: 'Save and Continue Later: Allow your respondents to save their form progress'
          },
          helpfulLinks.viewingResponses,
          helpfulLinks.allowingSubmissionEditing,
          helpfulLinks.limitingSubmissions
        ]
      },
      {
        description: 'Create specialised reports of your submitted data.',
        icon: files.responseFiltersIcon,
        title: 'Response Filters',
        id: 'response-filters',
        sections: [
          {
            description: `Make the most of your submission data by finding exactly what you need with easy-to-apply search filters. This also helps you create various segments from your responses which can also be used to generate reports or it can help you focus on a specific group of your submitted data.`,
            title: 'Create specialised reports of your submitted data',
            type: 'section'
          },
          {
            imageUrl: files.responseFiltersIllustration,
            type: 'tutorial'
          }
        ],
        links: [
          helpfulLinks.responseViews,
          helpfulLinks.deletingResponseFilters,
          helpfulLinks.editingResponseFilters,
          helpfulLinks.viewingResponses
        ]
      },
      {
        description: 'Export data to google sheets and as CSV and PDF.',
        icon: files.importExportDataIcon,
        title: 'Import/Export Data',
        id: 'import-export-data',
        sections: [
          {
            description: `Formplus comes with all the import and export functions that you are looking for in a form builder software. Import form submissions and data from a CSV file or export form data to a CSV file or use in Google Sheets.`,
            title: 'Import and export form data with ease',
            type: 'section'
          },
          {
            imageUrl: files.importExportDataIllustration,
            type: 'tutorial'
          },
          {
            description: 'Use the import data to harmonize form data from a CSV file into your Formplus database. This can be used to:',
            title: 'Importing Data',
            type: 'section',
            list: {
              items: [
                '<a href="https://www.formpl.us/features/pre-populate-form-fields" target="_blank">Prepopulate/prefill forms</a> with pre-existing data.',
                'Create forms that can <a href="https://www.formpl.us/features/pre-populate-form-fields" target="_blank">Lookup</a> other forms or look through an existing database.'
              ]
            },
            link: helpfulLinks.importingData
          },
          {
            description: 'Export your form data and reports into other formats to collaborate better with your team. With Formplus, you can export data to others in various formats - CSV, PDF or Google Sheets.',
            title: 'Export Data',
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.responseViews,
          helpfulLinks.deletingResponseFilters,
          helpfulLinks.editingResponseFilters,
          helpfulLinks.viewingResponses
        ]
      }
    ]
  },
  {
    description: 'Formplus forms makes sure that all connections between your web browser and our servers are secure 100% of the time.',
    image: files.securityIntro,
    title: 'Security',
    name: 'Security',
    id: 'security',
    subFeatures: [
      {
        description: `Maintain compliance with the European Union’s data privacy laws.`,
        icon: files.gdprCompliantIcon,
        title: 'GDPR Compliant',
        id: 'gdpr-compliant',
        sections: [
          {
            description: `Formplus is GDPR compliant and you can <a href="https://help.formpl.us/s/article/is-formplus-gdpr-compliant" target="_blank">read more</a> on the measures we have put in place to ensure this.
              <br /><br />
              To also help you maintain compliance with the European Union’s data privacy laws encompassed in the General Data Protection Regulation (GDPR). Formplus forms can be used to collect consent, share privacy policies and other important information.
              <br /><br />
              Any business that collects personal information from EU citizens or residents must first of all be GDPR compliant. Examples of such personal information include names, emails, addresses, and phone numbers.
            `,
            title: 'Create GDPR-compliant Consent forms',
            type: 'section'
          }
        ]
      },
      {
        description: 'Share forms privately with people on your team, or organisation.',
        icon: files.privateFormsIcon,
        title: 'Private Forms',
        id: 'private-forms',
        sections: [
          {
            description: `With Formplus forms, you can choose to share forms privately with people on your team, or organisation. All you need to is, add them to your Formplus account as team members.
              <br />
              <h3>How to submit entries on a private form.</h3>
              When a form is private, the only way to submit entries or view the form is to request access from the team administrator.
            `,
            title: 'Control who can view and submit entries to your online form',
            link: helpfulLinks.makeFormPrivate,
            type: 'section'
          }
        ]
      },
      {
        description: 'SSL (Secure Sockets Layer) remains the standard for ensuring data being sent a web server from a browser is encrypted.',
        title: 'SSL Enabled',
        icon: files.sslIcon,
        id: 'ssl-enabled',
        sections: [
          {
            description: `All Formplus forms are SSL enabled, making sure that all connections between your web browser and our servers are secure 100% of the time. SSL (Secure Sockets Layer) remains the standard for ensuring data being sent a web server from a browser is encrypted.
              <br /><br />
              To add an extra layer of security in your forms, you can use CAPTCHA to keep spam and bogus information from being submitted to your web forms. Overall, your information is protected and your site appears more professional.
            `,
            title: 'Your form data is safe with Formplus',
            link: helpfulLinks.makeFormPrivate,
            type: 'section'
          }
        ],
        links: [
          helpfulLinks.makeFormPrivate
        ]
      }
    ]
  }
];